export default "__VITE_ASSET__CnL8xyuq__"